import React, { useRef, useState } from 'react';
import { Formik, FormikProps } from 'formik';
import * as Yup from 'yup';
import * as Bixby from '$/core';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';
import Loading from '$/components/loading/Loading';
import { DataSiteService } from '$/services';
import './index.scss';
interface IUploadProps {
  setCurrentStage: (stage: Bixby.Enums.ClientDataSiteStage) => void;
  setCurrentVerificationResults: (results: Bixby.Models.ClientDataSiteVerificationSummary[]) => void;
  isMnpiUpload: boolean;
}

const Upload: React.FC<IUploadProps> = props => {
  const { setCurrentStage, setCurrentVerificationResults, isMnpiUpload } = props;

  const [fileName, setFileName] = useState('Choose a file or link');
  const [dataSiteFile, setDataSiteFile] = useState({} as Blob);
  const [verificationError, setVerificationError] = useState(undefined as string | undefined);
  const [isLoading, setIsLoading] = useState(false);
  const [verificationButtonEnabled, setVerificationButtonEnabled] = useState(false);

  const formikRef = useRef<FormikProps<any>>(null);
  const initialClientDataSiteValues = {};
  const schema = Yup.object({});

  const handleFileUpload = (event: any) => {
    if (event.target.files[0]) {
      setDataSiteFile(event.target.files[0]);
      setFileName(event.target.files[0].name);
      setVerificationButtonEnabled(true);
    } else {
      setDataSiteFile({} as Blob);
      setFileName('Choose a file or link');
      setVerificationButtonEnabled(false);
    }
  };

  const verifyDataSites = async () => {
    setIsLoading(true);
    setCurrentVerificationResults([]);
    setVerificationError(undefined);
    try {
      let results: Bixby.Models.ClientDataSiteVerificationSummary[];
      if (isMnpiUpload) {
        results = await DataSiteService.verifyMnpiDataSites(dataSiteFile);
      } else {
        results = await DataSiteService.verifyDataSites(dataSiteFile);
      }

      setCurrentVerificationResults(results);
      setIsLoading(false);
      setCurrentStage(Bixby.Enums.ClientDataSiteStage.Verification);
    } catch (e: any) {
      setIsLoading(false);
      const ex = e as any;
      const errorMessage: string =
        ex && ex.response && ex.response.data && ex.response.data.error
          ? ex.response.data.error
          : 'Error uploading client data sites';
      setVerificationError(errorMessage);
    }
  };

  return (
    <React.Fragment>
      <section>
        <div className="client_datasites">
          <section className="client_datasite_upload">
            <Formik
              innerRef={formikRef}
              initialValues={initialClientDataSiteValues}
              validationSchema={schema}
              onSubmit={async () => {
                await verifyDataSites();
              }}
              render={({ handleSubmit }) => (
                <form onSubmit={handleSubmit} className="profile-input-container">
                  <div className="profile-input-column">
                    <InputBlock title={`${isMnpiUpload ? 'Mnpi ' : 'Non-Mnpi '}Data Site File`}>
                      <input
                        id="file-upload"
                        className="hidden_file_input"
                        type="file"
                        onChange={handleFileUpload}
                        multiple={false}
                      />
                      <label htmlFor="file-upload">{fileName}</label>
                    </InputBlock>
                    {verificationError && <p className="error">{verificationError}</p>}
                    {isLoading && <Loading inline />}
                    {!isLoading && (
                      <BixButton type="submit" disabled={!verificationButtonEnabled}>
                        Upload Client Data Sites for Verification
                      </BixButton>
                    )}
                  </div>
                </form>
              )}></Formik>
          </section>
        </div>
      </section>
    </React.Fragment>
  );
};

export default Upload;
